// extracted by mini-css-extract-plugin
export default {"footer":"Footer_footer__XrM3i","row":"Footer_row__y33hK","poweredBy":"Footer_poweredBy__ErQGk","img":"Footer_img__eWhTD","footerLogo":"Footer_footerLogo__XtesN"};